import React, { Component } from 'react'
import styled from 'styled-components'
import axios from 'axios'
import ReactTable from 'react-table'
import { API_URL } from '../constants'
import { PageWrapper, FlexWrapper, SelectBox, Checkbox, Button, Modal, Header } from '../components'
import 'react-table/react-table.css'
import moment from 'moment'
import { get } from 'lodash'
import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body>div{
    max-width:100% !important;
  }
`

const TableWrap = styled.div`
  position: relative;
  .ReactTable.-striped.-highlight {
    padding-bottom: 50px;
  }
  .rt-thead.-header {
    background: #078489;
    color: #fff;
  }
  .rt-td {
    white-space: normal !important;
  }
  .pagination-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #078489;
    color: #fff;
  }
  .ReactTable .-pagination .-btn[disabled] {
    color: #fff;
    opacity: 0.9;
  }
  .ReactTable .-pagination .-btn {
    color: #fff;
  }
  .rt-tbody {
    /* min-width: 650px !important; */
    /* max-height: calc(100vh - 93px); */
  }
`
class ViewUserRedemption extends Component {
  state = {
    loader: false,
    userRedemptionsData: [],
    selectedOption: null,
    checked: false,
    checkedRows: [],
    checkAll: false,
    changeStatusModal: false,
    isSubmitLoading: false
  }
  componentDidMount() {
    this.getUserRedemptions()
  }

  getUserRedemptions = async () => {
    const query = {
      filter: {
        where: {
          referralDescription: get(this.props.match, 'params.id', ''),
          referralType: 'redeem',
          type: 'OUT'
        },
        include: ['user']
      }
    }
    try {
      const { data } = await axios.get(`${API_URL}/Referrals`, { params: { filter: query.filter } })
      this.setState({ userRedemptionsData: data })
    } catch (error) {
      console.log(error)
    }
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption: selectedOption })
  }

  submitStatus = async () => {
    this.setState({ isSubmitLoading: true })
    try {
      await axios.post(`${API_URL}/Referrals/bulk-approve`, {
        data: { ids: this.state.checkedRows, status: get(this.state.selectedOption, 'value', '') }
      })
      this.setState({ isSubmitLoading: false, changeStatusModal: false, checkedRows: [], checkAll: false })
      this.getUserRedemptions()
    } catch (error) {
      this.setState({ isSubmitLoading: false })
      console.log(error)
    }
  }

  checkRow(itemId, checked) {
    if (checked) {
      this.setState({ checkedRows: [...this.state.checkedRows, itemId] })
    } else {
      this.setState({
        checkedRows: this.state.checkedRows.filter(id => id !== itemId),
        checkAll: false
      })
    }
  }

  checkAll(checked) {
    if (checked) {
      this.setState({
        checkAll: true,
        checkedRows: this.state.userRedemptionsData.map(item => item.id)
      })
    } else {
      this.setState({
        checkedRows: [],
        checkAll: false
      })
    }
  }

  render() {
    const { userRedemptionsData, selectedOption, changeStatusModal, isSubmitLoading } = this.state

    return (
      <React.Fragment>
        <GlobalStyle />
        <Header
          icon="arrowBack"
          title="View User Redemption"
          onClickBack={() => this.props.history.goBack()}
          backgroundColor="#124b5f"
          style={{ minWidth: '100%' }}
          color="#fff"
        />
        <PageWrapper viewPadding="0 20px" height="auto" modifyPadding="0 20px" style={{ marginTop: 60 }}>
          <TableWrap>
            <ReactTable
              data={userRedemptionsData}
              columns={[
                {
                  Header: 'ID',
                  accessor: 'id',
                  width: 50
                },
                {
                  Header: 'Referral Type',
                  accessor: 'referralType',
                  width: 150
                },
                {
                  Header: row => {
                    console.log(get(row, 'original.id', ''))
                    return (
                      <React.Fragment>
                        <div>
                          Status
                          <Checkbox
                            checked={this.state.checkAll}
                            onChange={checked => this.checkAll(checked)}
                            borderColor="#fff"
                          />
                          Check All
                        </div>
                        <div onClick={() => this.setState({ changeStatusModal: true })}>
                          {this.state.checkedRows.length > 0 && <span>confirm</span>}
                        </div>
                      </React.Fragment>
                    )
                  },
                  accessor: 'status',
                  Cell: row => (
                    <React.Fragment>
                      <Checkbox
                        circle={false}
                        checked={this.state.checkedRows.indexOf(get(row.original, 'id', 0)) > -1}
                        onChange={checked => this.checkRow(get(row.original, 'id', 0), checked)}
                      />
                      {get(row, 'original.status', '')}
                    </React.Fragment>
                  ),
                  maxWidth: 200
                },
                {
                  Header: 'User Id',
                  accessor: 'userId',
                  width: 200
                },
                {
                  Header: 'User Name',
                  Cell: row => get(row.original, 'user.name', ''),
                  width: 200
                },
                {
                  Header: 'User Email',
                  Cell: row => get(row.original, 'user.email', ''),
                  width: 200
                },
                {
                  Header: 'Points',
                  accessor: 'points',
                  width: 150
                },
                {
                  Header: 'Redemption Code',
                  accessor: 'redemptionCode',
                  width: 150
                },
                {
                  Header: 'Date',
                  accessor: 'createdAt',
                  Cell: row =>
                    row.original.createdAt
                      ? moment(get(row.original, 'createdAt', '')).format('DD MMM YYYY HH:mm')
                      : '',
                  width: 150
                }
              ]}
              defaultPageSize={50}
              // pageSize={5}
              minRows={0}
              resizable={false}
              className="-striped -highlight"
            />
          </TableWrap>
        </PageWrapper>
        <Modal
          minHeight="500px"
          title={'Change status'}
          show={changeStatusModal}
          hide={!changeStatusModal}
          onClose={() => this.setState({ changeStatusModal: false })}>
          <FlexWrapper alignItems="center">
            <React.Fragment>
              <SelectBox
                name="status"
                options={[
                  { value: 'Pending', label: 'Pending' },
                  { value: 'Approved', label: 'Approved' },
                  { value: 'Reject', label: 'Reject' }
                ]}
                value={selectedOption}
                onChange={this.handleChange}
                selectField
              />
              <Button
                size="small"
                label="Submit"
                volume="filled"
                margin="14px 0 0 0"
                type="submit"
                isLoading={isSubmitLoading}
                disabled={isSubmitLoading}
                onClick={this.submitStatus}
              />
            </React.Fragment>
          </FlexWrapper>
        </Modal>
      </React.Fragment>
    )
  }
}
export default ViewUserRedemption



// WEBPACK FOOTER //
// ./src/pages/ViewUserRedemption.js